import { API_URL } from "@/config/constants";
import { parseContentDispositionFilename } from "@/utils/download-blob";
import axios from "axios";

import type { IArtifactGenerateRequest } from "./artifacts.types";

const API = `${API_URL}/artifacts`;

/**
 * POST JSON table data to `/api/v1/artifacts/generate` and receive an
 * xlsx Blob plus the filename parsed from the response's
 * `Content-Disposition` header.
 *
 * Filename resolution falls back in order: `Content-Disposition` header
 * -> `payload.filename` -> the `"polly-chart.xlsx"` default.
 */
export async function generateArtifact(
    payload: IArtifactGenerateRequest
): Promise<{ blob: Blob; filename: string }> {
    const response = await axios.post<Blob>(`${API}/generate`, payload, {
        responseType: "blob",
    });
    // Axios lowercases header keys.
    const headerFilename = parseContentDispositionFilename(
        response.headers["content-disposition"]
    );
    const filename = headerFilename ?? payload.filename ?? "polly-chart.xlsx";
    return { blob: response.data, filename };
}
